(() => {
  const rootSelector = '[data-ir-tracking-featured-root]';

  function init(root) {
    if (!root || root.dataset.irTrackingFeaturedReady === 'true') return;
    const viewport = root.querySelector('[data-ir-tracking-featured-slider]');
    if (!viewport || typeof window.Swiper !== 'function') return;

    root.dataset.irTrackingFeaturedReady = 'true';
    new window.Swiper(viewport, {
      loop: true,
      watchOverflow: true,
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 10,
      breakpoints: {
        768: { slidesPerView: 2, slidesPerGroup: 2, spaceBetween: 30 },
        1025: { slidesPerView: 4, slidesPerGroup: 4, spaceBetween: 30 }
      }
    });
  }

  function initAll(scope = document) {
    if (scope.matches && scope.matches(rootSelector)) init(scope);
    scope.querySelectorAll(rootSelector).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
